export default "__VITE_ASSET__83322540__"